"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlShader = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IGlShader}
 */
class GlShader {
    constructor(source, 
    /**
     * Absence indicates version agnostic.
     */
    requiredLanguageVersion) {
        this.source = source;
        this.requiredLanguageVersion = requiredLanguageVersion;
    }
    static getShaderFlag(flagName, value) {
        return [`#define `, flagName, value ? "1" : "0", `\n`].join(" ");
    }
    static getShaderInt(flagName, value) {
        return [`#define `, flagName, value, `\n`].join(" ");
    }
    static combineShaders(shaders) {
        let version = -1;
        for (let i = 0, iEnd = shaders.length; i < iEnd; ++i) {
            const shader = shaders[i];
            if (shader.requiredLanguageVersion != null && shader.requiredLanguageVersion > version) {
                version = shader.requiredLanguageVersion;
            }
        }
        const source = rc_js_util_1._Array
            .map(shaders, shader => shader.source)
            .join("\n");
        return new GlShader(source, version === -1 ? undefined : version);
    }
}
exports.GlShader = GlShader;
//# sourceMappingURL=gl-shader.js.map